module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('Menu', {
    ref: "mainMenu",
    attrs: {
      "theme": "dark",
      "accordion": true,
      "width": "160px",
      "active-name": _vm.activeName,
      "open-names": _vm.openNames
    },
    on: {
      "on-select": _vm.navToMenuItem
    }
  }, [_vm._l((_vm.menus), function(menuItem) {
    return [(!menuItem.children && (menuItem.meta && !menuItem.meta.notMenu)) ? _c('MenuItem', {
      key: menuItem.name,
      attrs: {
        "name": menuItem.name
      }
    }, [(menuItem.meta.icon) ? _c('Icon', {
      key: menuItem.name,
      attrs: {
        "type": menuItem.meta.icon
      }
    }) : _vm._e(), _vm._v("\n                " + _vm._s(menuItem.meta.title) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (menuItem.children && (menuItem.meta && !menuItem.meta.notMenu)) ? _c('Submenu', {
      key: menuItem.name,
      attrs: {
        "name": menuItem.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(menuItem.meta.icon) ? _c('Icon', {
      key: menuItem.name,
      attrs: {
        "type": menuItem.meta.icon
      }
    }) : _vm._e(), _vm._v("\n                        " + _vm._s(menuItem.meta.title) + "\n                        "), (menuItem.name === 'jiujingorder' && _vm.jiuJingConfirmOrders > 0) ? _c('span', {
      class: _vm.$style.menuTips
    }, [_vm._v(_vm._s(_vm.jiuJingConfirmOrders > 9 ? '9+' : _vm.jiuJingConfirmOrders))]) : _vm._e()], 1), _vm._v(" "), _vm._l((menuItem.children), function(subMenu) {
      return (!subMenu.meta.notMenu) ? _c('MenuItem', {
        key: subMenu.name,
        attrs: {
          "name": subMenu.name
        }
      }, [_vm._v(_vm._s(subMenu.meta.title))]) : _vm._e()
    })], 2) : _vm._e()]
  })], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('a', {
    staticClass: "brand-link",
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/0302a6c4b5c7692a71f3f904adce12d1/3flogo.svg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b0b4f2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/aside/main.vue
// module id = 914
// module chunks = 0